import styled from 'styled-components';

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: #192619;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
  color: #ABCDDF;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #2A3C29;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
`;

export const ModalFooter = styled.div`
  padding: 1.5rem;
  border-top: 1px solid #2A3C29;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;

  button {
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #ABCDDF;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: #E8FC8B;
  }
`;

export const TermsAndConditions = styled.div`
  background-color: #2A3C29;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const TermsStatus = styled.div`
  font-weight: bold;
  color: ${props => props.accepted ? '#E8FC8B' : '#FF6B6B'};
  margin-bottom: 0.5rem;
`;

export const TermsDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #ABCDDF80;
`;

export const TermsVersion = styled.span``;

export const TermsUpdatedOn = styled.span``;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const PaymentsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
`;

export const TableHeader = styled.th`
  padding: 1rem;
  text-align: left;
  background-color: #2A3C29;
  font-weight: 500;
  white-space: nowrap;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #2A3C29;
  }

  &:hover {
    background-color: #3A4C39;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  white-space: nowrap;
`;

export const PaymentType = styled.span`
  color: ${props => {
    switch (props.type) {
      case 'credit':
        return '#E8FC8B';
      case 'withdrawal':
        return '#FF6B6B';
      case 'deposit':
        return '#4ECDC4';
      default:
        return '#ABCDDF';
    }
  }};
  font-weight: 500;
`;

export const PaymentAmount = styled.span`
  color: ${props => {
    switch (props.type) {
      case 'credit':
        return '#E8FC8B';
      case 'withdrawal':
        return '#FF6B6B';
      case 'deposit':
        return '#4ECDC4';
      default:
        return '#ABCDDF';
    }
  }};
  font-weight: 500;
`;

export const PaymentRate = styled.span`
  color: #ABCDDF;
`;

export const PaymentMethod = styled.span`
  color: #ABCDDF;
`;

export const PaymentAddedBy = styled.span`
  color: #ABCDDF;
`;

export const PaymentTimestamp = styled.span`
  color: #ABCDDF80;
  font-size: 0.9rem;
`;

export const NoPayments = styled.div`
  text-align: center;
  padding: 2rem;
  color: #ABCDDF80;
`;

export const SortButton = styled.button`
  background: none;
  border: none;
  color: #ABCDDF;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: #E8FC8B;
  }
`;

export const NoBillingInfo = styled.div`
  text-align: center;
  padding: 2rem;
  color: #ABCDDF80;
  font-size: 1.1rem;
`;

export const TotalAvailable = styled.div`
  text-align: right;
  padding: 1rem;
  color: #E8FC8B;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
  background-color: #2A3C29;
  border-radius: 0.5rem;
`;

export const AddPaymentButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #E8FC8B;
  color: #1B2D1A;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`; 